import React, { useState } from "react";
import { Dropdown } from "primereact/dropdown";
import useDownloadPublisherCatalogueExport from "api/BulkBookImport/useDownloadPublisherCatalogueExport";
import StepPanel from "../StepPanel";
import StatusBanner from "../StatusBanner";

const FILTERS = [
	{ label: "Missing cover or PDF", value: "missing_any" },
	{ label: "Missing cover", value: "missing_cover" },
	{ label: "Missing PDF", value: "missing_pdf" },
	{ label: "Missing both", value: "missing_both" },
];

const DownloadBookListStep = ({ onContinue }) => {
	const [filter, setFilter] = useState("missing_any");
	const [downloaded, setDownloaded] = useState(false);
	const exportMutation = useDownloadPublisherCatalogueExport();

	const handleDownloadAndContinue = async () => {
		await exportMutation.mutateAsync(filter);
		setDownloaded(true);
		onContinue?.();
	};

	return (
		<StepPanel
			stepNumber={1}
			title="Download your book list"
			description="An Excel list of your books that are missing a cover, a PDF, or both."
			status={
				downloaded ? (
					<StatusBanner tone="success" title="Book list downloaded">
						Fill in cover_file and pdf_file, then upload this same file
						in step 2.
					</StatusBanner>
				) : null
			}
			nav={{
				hideBack: true,
				onNext: handleDownloadAndContinue,
				nextLabel: "Download & continue →",
				busy: exportMutation.isLoading,
				busyLabel: "Downloading…",
				extra: (
					<button
						type="button"
						className="rounded-lg border border-gray-200 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-50"
						disabled={exportMutation.isLoading}
						onClick={onContinue}
					>
						Skip — I already have my list →
					</button>
				),
			}}
		>
			<div className="space-y-3">
				<div>
					<label
						htmlFor="book-list-filter"
						className="mb-1 block text-sm font-medium text-gray-800"
					>
						Which books to include
					</label>
					<Dropdown
						inputId="book-list-filter"
						value={filter}
						options={FILTERS}
						onChange={(e) => setFilter(e.value)}
						className="w-full"
					/>
				</div>

				<details
					open
					className="rounded-lg border border-gray-100 bg-gray-50 bg-opacity-80 px-3 py-2 text-sm text-gray-700"
				>
					<summary className="cursor-pointer font-medium text-akgreenest">
						How to name your files
					</summary>
					<ul className="mt-2 list-disc space-y-1 pl-5 text-gray-700">
						<li>
							Rename covers/PDFs so the base name matches{" "}
							<code className="rounded bg-white px-1 py-0.5 text-xs">
								cover_file
							</code>{" "}
							/{" "}
							<code className="rounded bg-white px-1 py-0.5 text-xs">
								pdf_file
							</code>
							. Extensions may differ.
						</li>
						<li>
							Do not change{" "}
							<code className="rounded bg-white px-1 py-0.5 text-xs">
								book_id
							</code>
							.
						</li>
						<li>
							Example:{" "}
							<code className="rounded bg-white px-1 py-0.5 text-xs">
								123_The_Great_Adventure
							</code>{" "}
							→{" "}
							<code className="rounded bg-white px-1 py-0.5 text-xs">
								123_The_Great_Adventure.png
							</code>
						</li>
					</ul>
				</details>
			</div>
		</StepPanel>
	);
};

export default DownloadBookListStep;
